import { render, staticRenderFns } from "./FlexAdminSideNav.vue?vue&type=template&id=7865c084&scoped=true&"
import script from "./FlexAdminSideNav.vue?vue&type=script&lang=js&"
export * from "./FlexAdminSideNav.vue?vue&type=script&lang=js&"
import style0 from "./FlexAdminSideNav.vue?vue&type=style&index=0&id=7865c084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7865c084",
  null
  
)

export default component.exports